<p-table
  [value]="unprocessedDuplicatePlansEntries"
  [first]="first"
  (onLazyLoad)="loadData($event)"
  [lazy]="true"
  [totalRecords]="paginator.totalCount"
  [rows]="paginator.pageSize"
  [loading]="isLoading"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onPage)="pageChange($event)"
  [(selection)]="selectedTag"
  dataKey="entryId"
  [rowsPerPageOptions]="[10, 25, 50]"
>
  <ng-template #header>
    <tr>
      <th style="width: 25%">Filing Id</th>
      <th style="width: 25%">Filing Date</th>

      <th style="width: 25%">Trading Plan Id</th>
      <th style="width: 15%">URL</th>
      <th style="width: 33%">Action</th>
    </tr>
  </ng-template>
  <ng-template #body let-share>
    <tr
      [pSelectableRow]="share"
      [ngClass]="{
        'row-duplicate': share.status === 'DUPLICATE',
        'row-excluded': share.status === 'EXCLUDED'
      }"
    >
      <td>
        <a
          *ngIf="share.filingId; else empty"
          [href]="
            '/inbox?filingId=' + share.filingId + '&filingState=' + share.status
          "
          [style.color]="'#4a90e2'"
          [style.cursor]="'pointer'"
          [style.text-decoration]="'underline'"
          rel="noopener"
          target="_blank"
          >{{ share.filingId }}</a
        >

        <ng-template #empty>
          <span>-</span>
        </ng-template>
      </td>
      <td>{{ share.filingDate || "" }}</td>
      <td>{{ share.tradingPlanId || "N/A" }}</td>
      <td>
        <a href="{{ share.xbrlUrl }}" *ngIf="share.xbrlUrl" target="_blank"
          >Link</a
        >

        <span *ngIf="!share.xbrlUrl">-</span>
      </td>
      <!--      <td>{{ share.planAction || "N/A" }}</td>-->
      <td class="flex space-x-2">
        <button
          class="bg-white hover:bg-[#2a3450] text-#2a3450 cursor-pointer hover:text-white py-1 px-3 border border-gray-400 rounded mr-2"
          (click)="onExcludeClick(share, 'EXCLUDED')"
          [disabled]="share.status === 'EXCLUDED'"
        >
          Exclude
        </button>
        <button
          class="bg-white hover:bg-[#2a3450] text-#2a3450 cursor-pointer hover:text-white py-1 px-3 border border-gray-400 rounded mr-2"
          (click)="onExcludeClick(share, 'DUPLICATE')"
          [disabled]="share.status === 'DUPLICATE'"
        >
          Duplicate
        </button>
      </td>
    </tr>
  </ng-template>
</p-table>

<ng-container
  *ngIf="!isLoading && unprocessedDuplicatePlansEntries.length === 0"
>
  <div class="text-center py-6 text-gray-500">No record found</div>
</ng-container>
